'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = enhanceBeatle;

var _isPlainObject = require('lodash/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _connect = require('../base/connect');

var _connect2 = _interopRequireDefault(_connect);

var _injector = require('./injector');

var _injector2 = _interopRequireDefault(_injector);

var _asyncComponent = require('./asyncComponent');

var _asyncComponent2 = _interopRequireDefault(_asyncComponent);

var _service = require('./service');

var _service2 = _interopRequireDefault(_service);

var _baseSelector = require('./baseSelector');

var _baseSelector2 = _interopRequireDefault(_baseSelector);

var _baseModel = require('./baseModel');

var _baseModel2 = _interopRequireDefault(_baseModel);

var _events = require('events');

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _fromEvent = require('rxjs/observable/fromEvent');

var _crud = require('./crud');

var _crud2 = _interopRequireDefault(_crud);

var _seed = require('../seed');

var _seed2 = _interopRequireDefault(_seed);

var _action = require('../seed/action');

var _isReactComponent = require('../core/isReactComponent');

var _isReactComponent2 = _interopRequireDefault(_isReactComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emitter = new _events.EventEmitter();
// #! 自增唯一标识
var increment = 0;
function guid(name) {
  return name + ++increment;
}

var globalInjector = new _injector2.default();

function enhanceBeatle(Beatle) {
  var _class, _temp;

  return _temp = _class = function (_Beatle) {
    (0, _inherits3.default)(Damo, _Beatle);

    function Damo() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      (0, _classCallCheck3.default)(this, Damo);

      opt.injector = new _injector2.default(opt && opt.providers);
      opt.globalInjector = globalInjector;
      return (0, _possibleConstructorReturn3.default)(this, (Damo.__proto__ || Object.getPrototypeOf(Damo)).call(this, opt));
    }

    /**
     * ### Beatle新增Api
     *
     * | 方法 | 参数类型 | 描述 |
     * |: ------ |: ------ |: ------ |
     * | observable(obj) `Observable` | obj `Object` | 把数据转变为可观察队列，通过Rxjs来做序列进行转换 |
     * | select(nestKey, isObservable) `Object` | nestKey `String`, isObservable `Boolean` | 直接从store中获取指定model下的数据, 可转为序列 |
     * | service(Selector: BaseSelector, Component: ReactComponent, Providers: Array) `Component` | N/A | 注册服务, 并绑定到组件 |
     * | view(Selector: BaseSelector, Component: ReactComponent, Providers: Array) `Component` | N/A | 封装组件，生成视图 |
     */

    (0, _createClass3.default)(Damo, [{
      key: 'observer',
      value: function observer(originData, Com) {
        var _this2 = this;

        if (Com && (0, _isReactComponent2.default)(Com)) {
          return this.connect(originData, Com, (0, _isPlainObject2.default)(originData));
        }
        if (!originData) {
          originData = '';
        }
        var callback = Com;
        if (typeof originData === 'function' || typeof originData === 'string') {
          // #! 这里有问题，要通过store.subscribe来实现
          var store = this.seed.get('store');
          var str = originData;
          var states = this.select(str);
          var eventName = guid('event');
          var unsubscribe = void 0;
          var trySubscribe = function trySubscribe() {
            unsubscribe && unsubscribe();
            unsubscribe = store.subscribe(function () {
              var _states = _this2.select(str);
              if (Array.isArray(states) && states.filter(function (state, index) {
                return !(0, _isEqual2.default)(state, _states[index]);
              }).length || !(0, _isEqual2.default)(_states, states)) {
                // 第一次进来后，后续要判断新的变化才
                var nextState = _states;
                emitter.emit(eventName, _states && _states.asMutable ? _states.asMutable({ deep: true }) : _states);
                if (callback) {
                  callback(nextState, states);
                  states = nextState;
                } else {
                  states = nextState;
                  trySubscribe();
                }
              }
            });
          };
          trySubscribe();
          originData = (0, _fromEvent.fromEvent)(emitter, eventName);
          return _asyncComponent2.default.observable(originData);
        } else {
          return _asyncComponent2.default.observable(originData);
        }
      }
    }, {
      key: 'put',
      value: function put(name) {
        var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var _ReduxSeed$getRedux = _seed2.default.getRedux(this._setting.seedName),
            models = _ReduxSeed$getRedux.models;

        var model = models[name];
        if (model) {
          return this.dispatch({
            type: model.ACTION_TYPE_IMMEDIATE,
            payload: state
          });
        } else {
          return Promise.reject(false);
        }
      }
    }, {
      key: 'select',
      value: function select(keyStr, noFlattern, wrappers) {
        var _this3 = this;

        var _ReduxSeed$getRedux2 = _seed2.default.getRedux(this._setting.seedName),
            store = _ReduxSeed$getRedux2.store,
            actions = _ReduxSeed$getRedux2.actions;

        var allState = store.getState();
        var redux = {
          state: allState,
          actions: actions,
          put: function put(name, state) {
            return _this3.put(name, state);
          },
          select: function select(name, noFlattern) {
            return _this3.select(name, noFlattern);
          }
        };
        var dispatch = this.dispatch.bind(this);
        var state = void 0;
        if (typeof keyStr === 'function') {
          state = keyStr(allState);
        } else if (keyStr) {
          state = (0, _action.getStateByModels)(redux, [].concat(keyStr), !noFlattern, wrappers || {
            state: function state(d) {
              return _this3.seed._isImmutable ? _this3.seed.serialize(d) : d;
            },
            actions: function actions(_actions) {
              return (0, _action.getActionsByDispatch)(_actions, dispatch);
            }
          }, {});
        } else {
          state = allState;
        }
        return state;
      }
    }, {
      key: 'service',
      value: function service(providers, isGlobal) {
        var injector = void 0;

        if (typeof providers === 'string') {
          if (typeof isGlobal === 'function') {
            isGlobal.displayName = providers;
            providers = isGlobal;
            isGlobal = arguments[2];
          } else {
            // #! 获取指定服务
            injector = isGlobal ? globalInjector : this.injector;
            return injector.getService(providers);
          }
        }
        injector = isGlobal ? globalInjector : this.injector;
        if (!(0, _isPlainObject2.default)(providers)) {
          providers = [].concat(providers || []);
        }
        // #! 否则注入到全局服务中
        this.injector.setServices(providers);
      }
    }, {
      key: 'view',
      value: function view(selector, SceneComponent, providers, bindings, hookActions, props, getProps, flattern) {
        var _this4 = this;

        var newComponent = SceneComponent;
        if (selector !== false) {
          if (selector && (0, _isReactComponent2.default)(selector)) {
            getProps = props;
            props = hookActions;
            hookActions = bindings;
            bindings = providers;
            providers = SceneComponent;
            SceneComponent = selector;
            selector = null;
          }
          // #! selector实例
          if (selector && selector.prototype instanceof _baseSelector2.default) {
            selector.displayName = selector.displayName || guid('selector');
            selector = this.injector.instantiate(selector);
            selector.bindings = selector.bindings || bindings;
            selector.hookActions = selector.hookActions || hookActions;
          } else {
            if (Object(selector) !== selector) {
              bindings = bindings || selector;
              selector = new _baseSelector2.default();
              selector.bindings = [].concat(bindings || '');
            }
            selector.hookActions = hookActions;
          }
          if (selector.bindings) {
            Object.assign(selector, this.toBindings(selector.bindings, flattern || selector.flattern, selector));
          }
          // #! 绑定组件, 连接到redux
          newComponent = (0, _connect2.default)(selector, this.dispatch.bind(this), props, getProps)(SceneComponent);
          // #! 额外注入context到组件中

          selector.getModel = function (name) {
            return _this4.model(name);
          };
        }

        return (0, _service2.default)(providers, newComponent, {
          injector: this.injector,
          globalInjector: globalInjector,
          selector: selector
        }, SceneComponent);
      }
    }]);
    return Damo;
  }(Beatle), _class.crud = _crud2.default, _class.exec = _baseModel.exec, _class.action = _baseModel.action, _class.observable = _baseModel.observable, _class.computed = _baseModel.computed, _class.BaseModel = _baseModel2.default, _class.BaseSelector = _baseSelector2.default, _class.Injector = _injector2.default, _class.AsyncComponent = _asyncComponent2.default, _temp;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/damo/index.js
// module id = 124
// module chunks = 0